import apiClient from './client';
import { trackEvent } from './analyticsService';

// GET /api/v1/features returns only the opaque public ids of the flags that are ON for the
// current user — never flag names. See src/config/featureFlags.ts.
export const featureFlagsService = {
    getEnabled: async (): Promise<string[]> => {
        const response = await apiClient.get<{ f: string[] }>('/api/v1/features');
        return response.data?.f ?? [];
    },
};

// Records a meaningful use of a flagged feature (e.g. trackFeatureUsed(FF_STORY_MODE, 'generated')).
// Shows up in the admin dashboard's feature flag Stats tab.
export function trackFeatureUsed(flagId: string, action?: string): void {
    trackEvent('feature_used', { f: flagId, action, app: 'web' });
}
